import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

import { SocketHandler, SocketHandlerEvents } from '../../types';

export const SOCKET_HANDLER_EVENTS: SocketHandlerEvents = eventGroup({
  events: {
    dispatchDashboardEvent: type<SocketHandler>(),
    resetDashboardEvent: type<void>(),
  },
  source: 'Socket Handler Events',
});
